import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import '../../pages/Category/Cemetery/Cemetery.scss';

function UserNotLoggedIn() {
    return (
        <div className='userNotLoggedIn_container'>
            <Container className='inner_container'>
                <p> You want to see your list? Please continue to &nbsp;<Link to='/sign-in'>Log In</Link>.</p>
            </Container>
        </div>
    )
}

export default UserNotLoggedIn